import { MonetizationType } from '@/@types/graphql-types';

export type JWTVOfferType = 'AVOD' | 'TVOD' | 'SVOD';

export type JWTVProviderConfig = {
	shortName: string;
	type: JWTVOfferType;
	monetizationTypes: MonetizationType[];
};

export const JWTV_PROVIDER_CONFIG: JWTVProviderConfig[] = [
	{ shortName: 'jwt', type: 'AVOD', monetizationTypes: [MonetizationType.Free, MonetizationType.Ads] },
	{ shortName: 'jwt', type: 'TVOD', monetizationTypes: [MonetizationType.Buy, MonetizationType.Rent] },
	{ shortName: 'jst', type: 'TVOD', monetizationTypes: [MonetizationType.Buy, MonetizationType.Rent] },
	{ shortName: 'jut', type: 'SVOD', monetizationTypes: [MonetizationType.Flatrate] },

	{ shortName: 'fit', type: 'AVOD', monetizationTypes: [MonetizationType.Free, MonetizationType.Ads] },
];

type MinimalOffer = {
	package: { shortName: string };
	monetizationType: MonetizationType;
	country: string;
};

export function isJWTVOffer(offer: MinimalOffer): boolean {
	return JWTV_PROVIDER_CONFIG.some(
		config =>
			config.shortName === offer.package.shortName && config.monetizationTypes.includes(offer.monetizationType)
	);
}

export function getJWTVOffer<T extends MinimalOffer>(
	offers: T[],
	country: string,
	type?: JWTVOfferType
): T | undefined {
	for (const config of JWTV_PROVIDER_CONFIG) {
		if (type && config.type !== type) continue;
		const match = offers.find(
			offer =>
				offer.package.shortName === config.shortName &&
				config.monetizationTypes.includes(offer.monetizationType) &&
				offer.country === country
		);
		if (match) return match;
	}
	return undefined;
}
